import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import './FeatuersContactForm.css';

const ContactFormMain = () => {
  const onSubmit = async event => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append('access_key', 'ee8fa2ec-efa3-4347-a8ac-cbc23c369239');

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: json,
    }).then(res => res.json());

    if (res.success) {
      toast.success('Login successfully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
        // transition: Bounce,
      });
    }
  };

  return (
    <div className="contact-form-container- ">
      <form className="contact-form" onSubmit={onSubmit}>
        {/* onSubmit={handleSubmit}  */}
        <h2 className="form-heading-">Contact Us</h2>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            // value={formData.name}
            // onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            // value={formData.email}
            // onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            name="phone"
            // value={formData.phone}
            // onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Message</label>
          <textarea
            name="message"
            // value={formData.message}
            // onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Select Course</label>
          <select
            name="selection"
            // value={formData.selection}
            // onChange={handleChange}
            required
          >
            <option value="">Plese select an option</option>
            <option value="Basis Qaida For  Bigners">Basis Qaida For Bigners</option>
            <option value="Quran Recitation ">Quran Recitation </option>
            <option value="Quran Memorization">Quran Memorization</option>
            <option value=" Quran Tafseer"> Quran Tafseer</option>
            <option value="Quran Tajweed ">Quran Tajweed </option>
            <option value="Quran With Translation">Quran With Translation</option>
          </select>
        </div>
        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default ContactFormMain;
